import { ThemeMode } from "src/stores/useSettingsStore";

export const PREFERS_DARK_QUERY = "(prefers-color-scheme: dark)";

/**
 * Resolves whether the dark theme should be shown for a theme preference.
 *
 * @param mode - The user's theme preference
 * @param systemPrefersDark - Whether the OS currently prefers a dark scheme
 */
export function resolveIsDarkMode(
  mode: ThemeMode,
  systemPrefersDark: boolean,
): boolean {
  switch (mode) {
    case "dark":
      return true;
    case "light":
      return false;
    case "system":
    default:
      return systemPrefersDark;
  }
}

/** Reads the OS colour-scheme preference; false when matchMedia is unavailable. */
export function systemPrefersDark(): boolean {
  return (
    typeof window !== "undefined" &&
    typeof window.matchMedia === "function" &&
    window.matchMedia(PREFERS_DARK_QUERY).matches
  );
}
